import React from 'react';
import { classnames } from '../../../../utils/classnames';
import './textArea.css';
import InputErrors, {withErrors} from "../inputErrors/inputErrors";
import { useTranslation } from 'react-i18next';

export default function TextArea ({
    uniqueKey,
    placeholder = null,
    className = '',
    description = null,
    onChange = () => {},
    value = '',
    disabled = false,
    errors = null,
    label = null,
    maxLength = 300,
    disableResize = false,
    display = true,
    required= false,
    ...rest
}) {
    const { t } = useTranslation();
    const [valueLength, setValueLength] = React.useState(
        value?.length || 0
    );

    const _onChange = React.useCallback(event => {
        if (onChange) {
            onChange(event)
        }
        setValueLength(event.target.value?.length || 0);
    }, [onChange]);

	const getKey = (element = '') => uniqueKey ? `field_${uniqueKey}${element ? '_' + element : ''}` : null;

    if (!display) {
        return null
    }

    return (
        <div className={classnames('neo-textarea-content', className)}>
            {label && <label className='neo-input-label' htmlFor={getKey()}>{label}{required && <span aria-label={t('widget.required-field')} className='neo-required'> *</span>}</label>}
            {description && <p className='neo-input-description' id={getKey('description')}>{description}</p>}
            <textarea
                id={getKey()}
                className={classnames('neo-textarea', className, {'error': withErrors(errors), 'disabled': disabled, 'disable-resize': disableResize})}
                onChange={_onChange} 
                placeholder={placeholder}
                aria-invalid={withErrors(errors)}
                aria-required={required}
                aria-describedby={`${getKey('description')} ${getKey('error')}`}
                value={value}
                disabled={disabled}
                maxLength={maxLength}
                {...rest}
            />
            <span className={classnames("neo-textarea-footer", {'error': withErrors(errors)})}>
                <InputErrors errors={errors} id={getKey('error')}/>
                <div className="neo-textarea-length">
                    {valueLength || 0}
                    {maxLength ? `/${maxLength}` : null}
                </div>
            </span>
        </div>
    )
}